import React from "react";
import { RADIUS_ALL, RADIUS_OPTIONS } from "./inlineFilterConfig";
import SingleSelectFilter from "./SingleSelectFilter";

type RadiusFilterProps = {
    disabled?: boolean;
    label: string;
    radiusAllLabel: string;
    radiusLabel: (radius: number) => string;
    selectedValue: string;
    onChange: (value: string) => void;
};

const RadiusFilter: React.FC<RadiusFilterProps> = ({
    disabled = false,
    label,
    radiusAllLabel,
    radiusLabel,
    selectedValue,
    onChange,
}) => {
    const options = RADIUS_OPTIONS.map((radius) => ({ value: String(radius), label: radiusLabel(radius) }));

    return (
        <SingleSelectFilter
            clearOption={{ value: RADIUS_ALL, label: radiusAllLabel }}
            disabled={disabled}
            label={label}
            options={options}
            selectedValue={selectedValue || RADIUS_ALL}
            onChange={onChange}
        />
    );
};

export default RadiusFilter;
